import { Box, makeStyles, Grid, Paper } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import {
  Route,
  Switch,
  Redirect,
  useHistory,
  useLocation,
  Prompt,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import FinancialDashboard from "./financial-dashboard/Index";
import UserProfile from "./admin/components/UserProfile";
import {
  setUnsavedChangesUnnamed,
  setUnsavedChangesNamed,
  setUnsavedChangesProjectDetails,
  setUnsavedChangesGanttByDep,
  setUnsavedChangesGanttNotifications,
  setUnsavedChangesGanttNotificationsUnnamed,
} from "./../actions/common-actions";
import {
  FinancialDashboardIcon,
  ProjectManagementIcon,
  ResourceManagementIcon,
  BIDashboardsIcon,
} from "../shared-resources/SVGIcons";
import AIChat from "./ai-chat/Index";
import { clearChat } from "actions/chat-actions";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import ReportsCatalog from "./powerbi/ReportsCatalog";
import "./powerbi/reportFonts";
import PLByProgram from "./powerbi/reports/PLByProgram";
import WaterfallEAC from "./powerbi/reports/WaterfallEAC";
import LaborUtilization from "./powerbi/reports/LaborUtilization";
import MonthlyTMHours from "./powerbi/reports/MonthlyTMHours";
import TMProfitability from "./powerbi/reports/TMProfitability";
import MonthlyDFR from "./powerbi/reports/MonthlyDFR";
import AOPBudget from "./powerbi/reports/AOPBudget";
import FTEReport from "./powerbi/reports/FTEReport";
import ProjectManagementReviews from "./powerbi/reports/ProjectManagementReviews";
import ScenarioMoM from "./powerbi/reports/ScenarioMoM";
import ScenarioYoY from "./powerbi/reports/ScenarioYoY";
import ForecastMonthlySummary from "./powerbi/reports/ForecastMonthlySummary";
import Heatmap from "./powerbi/reports/Heatmap";
import FundingExpenditure from "./powerbi/reports/FundingExpenditure";
import ExceptionReport from "./powerbi/reports/ExceptionReport";
import L2TechHeatmap from "./powerbi/reports/L2TechHeatmap";
import IndirectReport from "./powerbi/reports/IndirectReport";
import SummaryVsBudget from "./powerbi/reports/SummaryVsBudget";
import ContractNotes from "./powerbi/reports/ContractNotes";
import AdjustedBillRate from "./powerbi/reports/AdjustedBillRate";

const useStyles = makeStyles((theme) => ({
  tabPaper: {
    margin: "16px",
    boxShadow: "0px 3px 6px #00000029",
    borderRadius: "8px",
  },
  secondTabGrid: {},
  thirdTabGrid: {
    float: "right",
  },
  selectedTab: {
    cursor: "pointer",
    padding: "8px 12px 8px 36px",
    borderRadius: "25px",
    color: "#fff",
    background: "#085F93",
    width: "248px",
    position: "relative",
  },
  nonSelectedTab: {
    cursor: "pointer",
    padding: "8px 12px 8px 36px",
    borderRadius: "25px",
    color: "#085F93",
    width: "248px",
    position: "relative",
    border: "1px solid #085F93",
    fontWeight: 600,
  },
  selectedTabBI: {
    cursor: "pointer",
    padding: "8px 12px 8px 36px",
    borderRadius: "25px",
    color: "#fff",
    background: "#085F93",
    position: "relative",
    width: "100%",
  },
  nonSelectedTabBI: {
    cursor: "pointer",
    padding: "8px 12px 8px 36px",
    borderRadius: "25px",
    color: "#085F93",
    position: "relative",
    border: "1px solid #085F93",
    fontWeight: 600,
    width: "100%",
  },
  tabIcon: {
    position: "absolute",
    top: "8px",
    left: "12px",
  },
  tabIconReports: {
    position: "absolute",
    top: "10px",
    left: "12px",
  },
  betaBadge: {
    position: "absolute",
    bottom: "-8px",
    right: "8px",
    fontSize: "9px",
    fontWeight: 700,
    lineHeight: 1,
    padding: "2px 6px",
    borderRadius: "8px",
    background: "#f59e0b",
    color: "#fff",
    letterSpacing: "0.5px",
  },
}));

export default function LandingPage() {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [isItemAdd, setIsItemAdd] = useState(false);
  const [globalDates, setGlobaldates] = useState({ start: "", end: "" });

  const unsavedChangesNamed = useSelector(
    (state) => state.commonReducer.unsavedChangesNamed,
  );

  const unsavedChangesUnnamed = useSelector(
    (state) => state.commonReducer.unsavedChangesUnnamed,
  );

  const unsavedChangesProjectDetails = useSelector(
    (state) => state.commonReducer.unsavedChangesProjectDetails,
  );

  const unsavedChangesGanttByDep = useSelector(
    (state) => state.commonReducer.unsavedChangesGanttByDep,
  );

  const unsavedChangesGanttNotifications = useSelector(
    (state) => state.commonReducer.unsavedChangesGanttNotifications,
  );

  const unsavedChangesGanttNotificationsUnnamed = useSelector(
    (state) => state.commonReducer.unsavedChangesGanttNotificationsUnnamed,
  );
  function handleResourceRequest(val) {
    const newlyAddedResource =
      JSON.parse(localStorage.getItem("newlyAddedResource")) || [];
    let resourceNames = [];
    newlyAddedResource.forEach((val) => {
      resourceNames.push(val.resourceName);
    });
    if (resourceNames.length === 0) {
      history.push(val);
    }
    if (resourceNames.length >= 1) {
      let message;
      if (resourceNames.length === 1) {
        message = `You have requested resource (${resourceNames.join(
          ", ",
        )}) but you haven't requested any time for this resource!`;
      } else {
        message = `You have requested resources (${resourceNames.join(
          ", ",
        )}) but you haven't requested any time for those resources!`;
      }

      if (window.confirm(message)) {
        setIsItemAdd(true);
        localStorage.removeItem("newlyAddedResource");
        history.push(val);
      } else {
        setIsItemAdd(false);
      }
    }
  }

  const ensureReportsAccess = () => true;

  const onTabClick = (val) => {
    if (!ensureReportsAccess(val)) return;
    // Call handleResourceRequest
    handleResourceRequest(val);
  };

  const onBIDashboardsClick = () => {
    window.open(process.env.BI_DASBOARD_URL, "_blank").focus();
  };

  useEffect(() => {
    dispatch(setUnsavedChangesNamed(false));
    dispatch(setUnsavedChangesUnnamed(false));
    dispatch(setUnsavedChangesProjectDetails(false));
    dispatch(setUnsavedChangesGanttByDep(false));
    dispatch(setUnsavedChangesGanttNotifications(false));
    dispatch(setUnsavedChangesGanttNotificationsUnnamed(false));
  }, [location]);

  return (
    <>
      <Prompt
        when={
          unsavedChangesNamed ||
          unsavedChangesUnnamed ||
          unsavedChangesProjectDetails ||
          unsavedChangesGanttByDep ||
          unsavedChangesGanttNotifications ||
          unsavedChangesGanttNotificationsUnnamed
        }
        message={"There are unsaved changes. Do you want to go away?"}
      ></Prompt>
      {location.pathname !== "/projects/resource-allocation" &&
        location.pathname !== "/projects/resource-allocation-matrix" &&
        location.pathname !== "/projects/resources-chart" &&
        location.pathname !== "/projects/all-resources-allocation-chart" &&
        location.pathname !== "/projects/unnamed-search" &&
        location.pathname !==
          "/projects/unnamed-all-resources-allocation-chart" &&
        location.pathname !== "/projects/all-resources-allocation" &&
        location.pathname !== "/projects/project-resources-allocation" &&
        location.pathname !== "/projects/swap-resource" &&
        location.pathname !== "/projects/ai-chat" && (
          <>
            <Paper className={classes.tabPaper}>
              <Box
                display="flex"
                flexDirection="row"
                style={{ width: "100%", padding: "12px 0" }}
              >
                {/** {localStorage.getItem("roles") &&
                  (JSON.parse(localStorage.getItem("roles")).includes(
                    "MANAGER"
                  ) ||
                    JSON.parse(localStorage.getItem("roles")).includes(
                      "RM"
                    )) && (
                    <Box style={{ width: "21%", marginLeft: "2%" }}>
                      <div
                        className={
                          location.pathname ===
                            "/projects/project-management" ||
                          location.pathname === "/projects/project-details" ||
                          location.pathname === "/projects/request-resource"
                            ? classes.selectedTabBI
                            : classes.nonSelectedTabBI
                        }
                        onClick={() => {
                          localStorage.removeItem("currentPage");
                          localStorage.removeItem("notificationType");
                          onTabClick("/projects/project-management");
                        }}
                      >
                        <span className={classes.tabIcon}>
                          {location.pathname ===
                            "/projects/project-management" ||
                          location.pathname === "/projects/project-details" ||
                          location.pathname === "/projects/request-resource"
                            ? ProjectManagementIcon("#ffffff")
                            : ProjectManagementIcon("#09659c")}
                        </span>
                        <span className={classes.tabText}>
                          PROJECT MANAGEMENT
                        </span>
                      </div>
                    </Box>
                  )}

                <Box style={{ width: "21%", marginLeft: "4%" }} display="flex">
                  {localStorage.getItem("roles") &&
                    (JSON.parse(localStorage.getItem("roles")).includes(
                      "MANAGER"
                    ) ||
                      JSON.parse(localStorage.getItem("roles")).includes(
                        "RM"
                      )) && (
                      <div
                        className={
                          location.pathname ===
                            "/projects/resource-management" ||
                          location.pathname ===
                            "/projects/resource-allocation" ||
                          location.pathname ===
                            "/projects/resource-allocation-matrix" ||
                          location.pathname === "/projects/resources-chart" ||
                          location.pathname ===
                            "/projects/all-resources-allocation-chart" ||
                          location.pathname === "/projects/unnamed-search" ||
                          location.pathname ===
                            "/projects/unnamed-all-resources-allocation-chart" ||
                          location.pathname ===
                            "/projects/all-resources-allocation" ||
                          location.pathname ===
                            "/projects/project-resources-allocation" ||
                          location.pathname === "/projects/swap-resource"
                            ? classes.selectedTabBI
                            : classes.nonSelectedTabBI
                        }
                        onClick={() =>
                          onTabClick("/projects/resource-management")
                        }
                      >
                        <span className={classes.tabIcon}>
                          {location.pathname ===
                            "/projects/resource-management" ||
                          location.pathname ===
                            "/projects/resource-allocation" ||
                          location.pathname ===
                            "/projects/resource-allocation-matrix" ||
                          location.pathname === "/projects/resources-chart" ||
                          location.pathname ===
                            "/projects/all-resources-allocation-chart" ||
                          location.pathname === "/projects/unnamed-search" ||
                          location.pathname ===
                            "/projects/unnamed-all-resources-allocation-chart" ||
                          location.pathname ===
                            "/projects/all-resources-allocation" ||
                          location.pathname ===
                            "/projects/project-resources-allocation" ||
                          location.pathname === "/projects/swap-resource"
                            ? ResourceManagementIcon("#ffffff", "#ffffff")
                            : ResourceManagementIcon("#09659c", "#085f93")}
                        </span>
                        <span className={classes.tabText}>
                          RESOURCE MANAGEMENT
                        </span>
                      </div>
                    )}
                </Box>*/}
                <Box style={{ width: "21%", marginLeft: "1%" }} display="flex">
                  {localStorage.getItem("roles") &&
                    (JSON.parse(localStorage.getItem("roles")).includes("SU") ||
                      JSON.parse(localStorage.getItem("roles")).includes(
                        "DPM",
                      ) ||
                      JSON.parse(localStorage.getItem("roles")).includes(
                        "PC",
                      ) ||
                      JSON.parse(localStorage.getItem("roles")).includes(
                        "OV",
                      ) ||
                      JSON.parse(localStorage.getItem("roles")).includes(
                        "PM",
                      )) && (
                      <div
                        className={
                          location.pathname === "/projects/financial-dashboard"
                            ? classes.selectedTabBI
                            : classes.nonSelectedTabBI
                        }
                        onClick={() =>
                          onTabClick("/projects/financial-dashboard")
                        }
                      >
                        <span className={classes.tabIcon}>
                          {location.pathname === "/projects/financial-dashboard"
                            ? ResourceManagementIcon("#ffffff", "#ffffff")
                            : ResourceManagementIcon("#09659c", "#085f93")}
                        </span>
                        <span className={classes.tabText}>
                          FINANCIAL MANAGEMENT
                        </span>
                      </div>
                    )}
                </Box>
                <Box style={{ width: "21%", marginLeft: "4%" }} display="flex">
                  {localStorage.getItem("roles") &&
                    (JSON.parse(localStorage.getItem("roles")).includes("SU") ||
                      JSON.parse(localStorage.getItem("roles")).includes(
                        "DPM",
                      ) ||
                      JSON.parse(localStorage.getItem("roles")).includes(
                        "PC",
                      ) ||
                      JSON.parse(localStorage.getItem("roles")).includes(
                        "OV",
                      ) ||
                      JSON.parse(localStorage.getItem("roles")).includes(
                        "PM",
                      )) && (
                      <div
                        className={
                          location.pathname.startsWith("/projects/reports")
                            ? classes.selectedTabBI
                            : classes.nonSelectedTabBI
                        }
                        onClick={() => onTabClick("/projects/reports/catalog")}
                      >
                        <span className={classes.tabIcon}>
                          {location.pathname.startsWith("/projects/reports")
                            ? FinancialDashboardIcon("#ffffff", "#ffffff")
                            : FinancialDashboardIcon("#09659c", "#085f93")}
                        </span>
                        <span className={classes.tabText}>REPORTS</span>
                      </div>
                    )}
                </Box>
                <Box style={{ width: "21%", marginLeft: "4%" }} display="flex">
                  {localStorage.getItem("roles") &&
                    (JSON.parse(localStorage.getItem("roles")).includes("SU") ||
                      JSON.parse(localStorage.getItem("roles")).includes(
                        "DPM",
                      ) ||
                      JSON.parse(localStorage.getItem("roles")).includes(
                        "PC",
                      ) ||
                      JSON.parse(localStorage.getItem("roles")).includes(
                        "OV",
                      ) ||
                      JSON.parse(localStorage.getItem("roles")).includes(
                        "PM",
                      )) && (
                      <div
                        className={
                          location.pathname === "/projects/ai-chat"
                            ? classes.selectedTabBI
                            : classes.nonSelectedTabBI
                        }
                        onClick={() => {
                          dispatch(clearChat());
                          onTabClick("/projects/ai-chat");
                        }}
                      >
                        <span className={classes.tabIcon}>
                          <ChatBubbleOutlineIcon
                            style={{
                              fontSize: 18,
                              color:
                                location.pathname === "/projects/ai-chat"
                                  ? "#ffffff"
                                  : "#085f93",
                            }}
                          />
                        </span>
                        <span className={classes.tabText}>Fin Assist</span>
                        <span className={classes.betaBadge}>BETA</span>
                      </div>
                    )}
                </Box>

                {/*<Box style={{ width: "21%", marginLeft: "4%" }} display="flex">
                  {localStorage.getItem("roles") &&
                    (JSON.parse(localStorage.getItem("roles")).includes(
                      "MANAGER"
                    ) ||
                      JSON.parse(localStorage.getItem("roles")).includes(
                        "RM"
                      )) && (
                      <div
                        className={
                          location.pathname === "/projects/reports"
                            ? classes.selectedTabBI
                            : classes.nonSelectedTabBI
                        }
                        onClick={() => onTabClick("/projects/reports")}
                      >
                        <span className={classes.tabIconReports}>
                          {location.pathname === "/projects/reports"
                            ? FinancialDashboardIcon("#ffffff", "#ffffff")
                            : FinancialDashboardIcon("#09659c", "#085f93")}
                        </span>
                        <span className={classes.tabText}>REPORTS</span>
                      </div>
                    )}
                </Box>*/}
              </Box>
            </Paper>
          </>
        )}

      <Switch>
        <Route path="/projects/financial-dashboard">
          <FinancialDashboard />
        </Route>
        <Route path="/user-profile">
          <UserProfile />
        </Route>
        <Route path="/projects/ai-chat">
          <AIChat />
        </Route>
        <Route path="/projects/reports/pl_by_program/:tab?">
          <PLByProgram />
        </Route>
        <Route path="/projects/reports/waterfall_eac/:tab?">
          <WaterfallEAC />
        </Route>
        <Route path="/projects/reports/labor_utilization/:tab?">
          <LaborUtilization />
        </Route>
        <Route path="/projects/reports/monthly_tm_hours/:tab?">
          <MonthlyTMHours />
        </Route>
        <Route path="/projects/reports/tm_profitability/:tab?">
          <TMProfitability />
        </Route>
        <Route path="/projects/reports/monthly_dfr/:tab?">
          <MonthlyDFR />
        </Route>
        <Route path="/projects/reports/aop_budget/:tab?">
          <AOPBudget />
        </Route>
        <Route path="/projects/reports/fte_report/:tab?">
          <FTEReport />
        </Route>
        <Route path="/projects/reports/pm_reviews/:tab?">
          <ProjectManagementReviews />
        </Route>
        <Route path="/projects/reports/scenario_mom/:tab?">
          <ScenarioMoM />
        </Route>
        <Route path="/projects/reports/scenario_yoy/:tab?">
          <ScenarioYoY />
        </Route>
        <Route path="/projects/reports/forecast_monthly">
          <ForecastMonthlySummary />
        </Route>
        <Route path="/projects/reports/heatmap/:tab?">
          <Heatmap />
        </Route>
        <Route path="/projects/reports/funding_expenditure/:tab?">
          <FundingExpenditure />
        </Route>
        <Route path="/projects/reports/exception_report/:tab?">
          <ExceptionReport />
        </Route>
        <Route path="/projects/reports/l2_tech_heatmap/:tab?">
          <L2TechHeatmap />
        </Route>
        <Route path="/projects/reports/indirect_report/:tab?">
          <IndirectReport />
        </Route>
        <Route path="/projects/reports/summary_vs_budget/:tab?">
          <SummaryVsBudget />
        </Route>
        <Route path="/projects/reports/contract_notes/:tab?">
          <ContractNotes />
        </Route>
        <Route path="/projects/reports/adjusted_bill_rate">
          <AdjustedBillRate />
        </Route>
        <Route path="/projects/reports/catalog">
          <ReportsCatalog />
        </Route>
        <Route path="/projects/reports">
          <Redirect to="/projects/reports/catalog" />
        </Route>
      </Switch>
    </>
  );
}
